module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('em', [_vm._v("Epigraphic Conventions")])])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hroughout this book, the reader will notice numerous symbols, called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sigla")]), _vm._v(", associated with the Greek and Latin inscriptions that I cite, especially in “")]), _c('span', {
    attrs: {
      "href": "#/019_Appendix01#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Inscriptions")]), _vm._v(".” For this reason, this section provides a short explanation for each "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("siglum")]), _vm._v(" (the singular of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sigla")]), _vm._v(") that I use:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("[ ]")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A letter or letters within brackets are not present in the epigraph but are ones that an editor has restored.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("( )")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Letters within parentheses are part of the abbreviated form of a word and were omitted by the stonecutter to save space.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "charis"
  }, [_vm._v("˂")]), _vm._v(" "), _c('span', {
    staticClass: "charis"
  }, [_vm._v("˃")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Letters within angular brackets have been omitted or substituted by the stonecutter.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("[[ ]]")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Letters within double brackets have been erased in antiquity.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("{ }")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Letters within curved brackets are superfluous and have been inscribed by the stonecutter by mistake.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("[…]")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brackets with dots inside represent instances in which, while letters are missing, the number of them is known.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("[- - -]")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brackets with dashes inside represent instances in which, while the letters are missing, the number of them is unknown.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "charis"
  }, [_vm._v("α̣")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A letter with a dot under it means that it is only partially preserved in the inscription.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("α")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A letter with a line under it means that the letter is no longer visible, but an older editor of the epigraph noted its presence.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("vacat")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("This Latin verb, which means “it is empty or vacant,” indicates that the stonecutter has intentionally left a space in the epigraph in question.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9966d0b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_EpigraphicConventions.vue
// module id = 90
// module chunks = 0